import { CircularProgress, ListItem } from '@mui/material'
import React from 'react'

export const ListItemLoading: React.FC = () => (
  <ListItem
    data-testid="searchLoading"
    sx={{
      justifyContent: 'center',
      padding: 0,
      marginLeft: '-5px'
    }}>
    <CircularProgress size={20} />
  </ListItem>
)
